export default __webpack_public_path__ + "media/src/assets/images/TenderFile-9070684c25831027d8bb8d7daca13ebd.jpg";